<template>
  <b-card-body>
    <b-form-row>
      <b-col>
        <b-form-group label="Bedrag">
          <b-input-group>
            <b-input 
              v-model.number="activiteit.bedrag" 
              type="number"
            />
          
            <b-input-group-append>
              <b-dropdown text="%">
                <b-dropdown-item 
                  v-for="(i) in [5,10,25,33,50,75,100]" 
                  :key="i" 
                  @click="() => setPercentage(i)"
                >
                  {{ i }}%
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Moment">
          <b-select 
            v-model="activiteit.moment" 
            :options="['Bij start','Bij oplevering']"
          />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-group label="Notitie">
      <b-textarea v-model="activiteit.omschrijving" />
    </b-form-group>
  </b-card-body>
</template>
<script>
export default {
    name: 'FacturatieStap',
    props: {
      totaal: {
        type: Number,
        default: 100
      },
      activiteit: {
        type: Object,
        default: () => {
          return {
            notitie: null,
            bedrag: null,
            moment: null,
            toegewezen_aan: null,
            deadline: null
          }  
        }
      }
    },
    methods: {
      setPercentage(perc) {
        this.$set(this.activiteit, 'bedrag', (perc*(this.totaal/100)))
      }
    }
}
</script>